import moment from 'moment';
import React from 'react';
import { Dimmer, Form, Loader, Segment } from 'semantic-ui-react';

import { SelectorDeAlumnos } from './SelectorDeAlumnos';

export type Props = Readonly<{
    cargando: boolean;
    alumnos: ReadonlyArray<{
        numeroDeMatricula: number;
        nombre: string;
    }>;
    alIngresar: (datos: IngresoAtencion) => Promise<void>;
}>;

export interface IngresoAtencion {
    numeroDeMatricula: number;
    fechaYHora: string;
    ausente: boolean;
    excepcional: boolean;
}
type State = IngresoAtencion & { ingresando: boolean };

const StateInicial = {
    numeroDeMatricula: 0,
    fechaYHora: moment().format('YYYY-MM-DDTHH:mm'),
    ausente: false,
    excepcional: false,
    ingresando: false,
};

export class FormularioDeIngreso extends React.Component<Props, State> {
    public readonly state: State = StateInicial;

    public render() {
        const { cargando, alumnos } = this.props;
        const { numeroDeMatricula, fechaYHora, ingresando, ausente, excepcional } = this.state;

        return (
            <Dimmer.Dimmable
                as={Segment}
                dimmed={cargando}
                onSubmit={() => {
                    this.setState({ ingresando: true });
                    this.props
                        .alIngresar({
                            numeroDeMatricula,
                            fechaYHora,
                            ausente,
                            excepcional,
                        })
                        .then(() => this.setState(StateInicial))
                        .catch();
                }}
            >
                <Dimmer inverted active={cargando}>
                    <Loader inverted />
                </Dimmer>

                <Form>
                    <Form.Group>
                        <SelectorDeAlumnos
                            alumnos={alumnos}
                            numeroDeMatricula={numeroDeMatricula}
                            alSeleccionarAlumno={this.seleccionarAlumno}
                            width='7'
                        />
                        <Form.Input
                            label='Hora y fecha'
                            required
                            type='datetime-local'
                            value={fechaYHora}
                            onChange={(_, { value }) =>
                                this.setState({
                                    fechaYHora: value,
                                })
                            }
                            width='4'
                        />
                    </Form.Group>

                    <Form.Checkbox
                        label='Ausente'
                        checked={ausente}
                        onChange={() =>
                            this.setState(prevState => ({ ausente: !prevState.ausente }))
                        }
                    />
                    <Form.Checkbox
                        label='Excepcional'
                        disabled={ausente}
                        checked={excepcional}
                        onChange={() =>
                            this.setState(prevState => ({
                                excepcional: !prevState.excepcional,
                            }))
                        }
                    />

                    <Form.Button
                        primary
                        content='Ingresar'
                        loading={ingresando}
                        disabled={!numeroDeMatricula || !fechaYHora}
                        type='submit'
                    />
                </Form>
            </Dimmer.Dimmable>
        );
    }

    private readonly seleccionarAlumno = (numeroDeMatricula: number) => {
        this.setState({ numeroDeMatricula });
    };
}



// WEBPACK FOOTER //
// ./src/modulos/Psicopedagogia/componentes/FormularioDeIngreso.tsx